import { ArrowUpIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Textarea } from '@chakra-ui/react';
import { InputVariant } from 'presentation/theme/components/input';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TextareaAutosize from 'react-textarea-autosize';

interface Props {
  onSubmit: () => void;
  text: string;
  setText: (val: string) => void;
}

const CommentsInput: FC<Props> = ({ onSubmit, text, setText }) => {
  const { t } = useTranslation();

  return (
    <Flex alignItems="end">
      <Textarea
        fontSize="18px"
        py="15px"
        bgColor="#fff"
        borderRadius="18px"
        border="none"
        px="20px"
        placeholder={t('commentInputPlaceholder') ?? ''}
        mr="10px"
        value={text}
        variant={InputVariant.filled}
        _focus={{
          bgColor: '#fff',
        }}
        _hover={{
          bgColor: '#fff',
        }}
        onChange={(e) => setText(e.target.value)}
        maxLength={1000}
        onKeyDown={(e) => {
          if (
            e.key === 'Enter' &&
            !e.shiftKey &&
            !e.altKey &&
            !e.ctrlKey &&
            !e.metaKey
          ) {
            e.preventDefault();
            onSubmit();
          }
        }}
        resize="none"
        minH="unset"
        as={TextareaAutosize}
        maxRows={6}
        minRows={1}
      />
      <IconButton
        mb="7.5px"
        w="40px"
        h="40px"
        rounded="50%"
        aria-label={t('sendMessage')}
        icon={<ArrowUpIcon w="24px" h="24px" />}
        onClick={() => onSubmit()}
        disabled={!text.trim()}
      />
    </Flex>
  );
};

export default CommentsInput;
